import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09ea1e0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contentTow" }
const _hoisted_2 = { class: "Search_item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "检验日期", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_5 = { class: "Search_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "检验类型", -1))
const _hoisted_7 = { class: "Search_item_content" }
const _hoisted_8 = { class: "tag" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "content_total" }
const _hoisted_11 = { class: "content_list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "content_list_item_title" }
const _hoisted_14 = { class: "content_list_item_nr" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_nr_box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "检验类型："),
  /*#__PURE__*/_createElementVNode("div", { class: "cr" }, "品质终检")
], -1))
const _hoisted_16 = { class: "content_list_item_nr_box" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "物料信息：", -1))
const _hoisted_18 = { class: "cr" }
const _hoisted_19 = { class: "content_list_item_nr_box" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "工单编号：", -1))
const _hoisted_21 = { class: "cr" }
const _hoisted_22 = { class: "content_list_item_nr_boxs" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "送检数量：", -1))
const _hoisted_24 = { class: "cr" }
const _hoisted_25 = { class: "content_list_item_nr_box" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "检验日期：", -1))
const _hoisted_27 = { class: "cr" }

import { reactive, ref, onMounted } from "vue"
    import { useRouter } from "vue-router"
    import { useStore } from "vuex"
    import { gsdate, judgmentPlatform } from '@/utils/utils'
    import { page } from '@/apis/QualityAPI'
    import { getWorkingProcedure, ZJPage } from "@/apis/PlanningAPI"
    import { model } from '@/interface'
    import vSearch from '@/components/common/Search.vue'
    import vLableSelection from '@/components/common/LabelSelection.vue'

    interface page extends model {
        total: number,
        checkStartDate: string,
        checkEndDate: string,
        minParam: string,
        batch: string | number,
        checkType: string,
        procedureId: string
    }

    // 分页查询数据
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const pageData = reactive<page>({
        capacity: 10,
        page: 0,
        total: 0,
        checkStartDate: '',
        checkEndDate: '',
        minParam: '',
        batch: '',
        checkType: '',
        procedureId: ''
    })

    const store = useStore()

    const router = useRouter()

    const minDate: Date = new Date(2021, 0, 1)

    const maxDate: Date = new Date(new Date().getFullYear() + 1, 12, 30)

    let status = ref<boolean>(false)    // 根据平台是否需要设置top

    // 列表数据
    let listData: any = ref([])

    const openCode = ref<boolean>(false)

    // 检验类型
    let data: any = reactive([
        { id: '0', name: '检具检', isActive: true },
        { id: '1', name: '外观检', isActive: false }
    ])

    // 检验工序
    let workingProcedure: any = reactive([])

    const isOpenDate = ref(false)

    const list: any = ref([])
    const loading = ref(false)
    const finished = ref(false)
    const refreshing = ref(false)

    // 重置
    const reset = () => {
        pageData.checkType = ''
        pageData.page = 0
        pageData.checkStartDate = ''
        pageData.checkEndDate = ''
        finished.value = false
        list.value = []
        onLoad()
    }

    // 查询搜索
    const searchInput = (val: any) => {
        pageData.minParam = val
        pageData.page = 0
        listData.value = []
        finished.value = false
        onLoad()
    }

    // 搜索提交
    const submit = () => {
        data.forEach((item: any) => {
            if (item.isActive) {
                pageData.checkType = item.id
            }
        })
        workingProcedure.forEach((item: any) => {
            if (item.isActive) {
                pageData.procedureId = item.id
            }
        })
        pageData.page = 0
        listData.value = []
        finished.value = false
        onLoad()
    }

    // 跳转详情
    const jumpDesc = (item: any) => {
        router.push({ name: 'finalInspectionDetails', query: { id: item.id } })
    }

    // 打开日期选择组件
    const openDate = () => {
        isOpenDate.value = true
    }

    // 打开扫码组件
    const openScanCode = () => {
        openCode.value = true
    }

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 日期确认
    const onConfirm = (values: any) => {
        const [start, end] = values
        pageData.checkStartDate = gsdate(start)
        pageData.checkEndDate = gsdate(end)
        isOpenDate.value = false
    }

    // 切换检类型
    const changeTag = (i: any, id: string): void => {
        pageData.checkType = id
        data.forEach((item: { isActive: boolean; }, index: any) => {
            item.isActive = index === i;
        })
    }

    // 切换检工序
    const changeTag1 = (i: any): void => {
        workingProcedure.forEach((item: { isActive: boolean; }, index: any) => {
            item.isActive = index === i;
        })
    }

    // 获取扫码值
    const onDecode = (data: string[]): void => {
        console.log(data)
    }

    // 获取当前用户所分配的工序
    // const getWorkingProcedures = async () => {
    //     let res = await ZJPage({
    //         capacity: 100,
    //         page: 1,
    //         model: {
    //             checkTimeStart: pageData.checkStartDate,
    //             checkTimeEnd: pageData.checkEndDate,
    //             checkType: pageData.checkType
    //         }
    //     })
    //     if (res.code === 200 && res.data.records.length !== 0) {
    //         res.data.records.forEach((item: any, index: number) => {
    //             if (index === 0) {
    //                 workingProcedure.push({ id: item.id, name: item.name, isActive: true })
    //             } else {
    //                 workingProcedure.push({ id: item.id, name: item.name, isActive: false })
    //             }
    //         })
    //     }
    // }

    // 列表
    const onLoad = () => {
        if (!finished.value) {
            pageData.page = pageData.page + 1
            loading.value = true
            ZJPage({
                capacity: pageData.capacity,
                page: pageData.page,
                model: {
                    checkTimeStart: pageData.checkStartDate,
                    checkTimeEnd: pageData.checkEndDate,
                    checkType: pageData.checkType,
                    mixParam: pageData.minParam
                }
            }).then(res => {
                if (refreshing.value) {
                    listData.value = []
                    refreshing.value = false;
                }
                loading.value = false
                if (res.code === 200 && res.data.records && res.data.records.length !== 0) {
                    pageData.total = res.data.total
                    listData.value.push(...res.data.records)
                } else {
                    finished.value = true
                }
            }).catch(err => {
                loading.value = false
                finished.value = true
                if (refreshing.value) {
                    listData.value = []
                    refreshing.value = false;
                }
            })
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        pageData.page = 0
        loading.value = true;
        onLoad();
    }

    onMounted(() => {
        status.value = judgmentPlatform()
        // getWorkingProcedures()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'content_top': _unref(status) }, "content_search"])
    }, [
      _createVNode(vSearch, {
        placeholder: "搜索工单编号/物料编码",
        onSearchInput: searchInput,
        onReset: reset,
        onSubmit: submit,
        isShow: true
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "Search_item_content",
              onClick: openDate
            }, [
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(pageData).checkStartDate ? 'color: #000;' : '')
              }, _toDisplayString(_unref(pageData).checkStartDate ? _unref(pageData).checkStartDate : '开始日期'), 5),
              _hoisted_4,
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(pageData).checkEndDate ? 'color: #000;' : '')
              }, _toDisplayString(_unref(pageData).checkEndDate ? _unref(pageData).checkEndDate : '结束日期'), 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag_item", {'tag_active': item.isActive}]),
                    key: item.id,
                    onClick: ($event: any) => (changeTag(i, item.id))
                  }, _toDisplayString(item.name), 11, _hoisted_9))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", _hoisted_10, "共" + _toDisplayString(_unref(pageData).total) + "条数据", 1),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了~",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listData), (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "content_list_item",
                  key: i,
                  onClick: ($event: any) => (jumpDesc(item))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", null, _toDisplayString(item.code), 1),
                    (item.checkType === 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass([ item.doneType === 0 ? 'green' : 'red' ])
                        }, "检具检 - " + _toDisplayString(item.doneType === 0 ? '合格' : '不合格'), 3))
                      : _createCommentVNode("", true),
                    (item.checkType === 1)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass([ item.doneType === 0 ? 'green' : 'red' ])
                        }, "外观检 - " + _toDisplayString(item.doneType === 0 ? '合格' : '不合格'), 3))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.materialName) + "丨" + _toDisplayString(item.materialCode), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, _toDisplayString(item.workOrderCode), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, _toDisplayString(item.num), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, _toDisplayString(item.createTime), 1)
                    ])
                  ])
                ], 8, _hoisted_12))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_van_calendar, {
      show: isOpenDate.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((isOpenDate).value = $event)),
      "min-date": _unref(minDate),
      "max-date": _unref(maxDate),
      type: "range",
      color: "#4275FC",
      onConfirm: onConfirm
    }, null, 8, ["show", "min-date", "max-date"])
  ]))
}
}

})